'use client';

import { AdminMantineProvider } from '../../components/admin/AdminMantineProvider';

export default function AdminLayout({ children }: { children: React.ReactNode }) {
    return <AdminMantineProvider>{children}</AdminMantineProvider>;
}
